


























import { Component, Prop, Vue } from "vue-property-decorator";
import { SurveyItem } from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class TextAreaItem extends Vue {
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({ type: String, default: "" })
  value!: string;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  localValue!: string;

  created() {
    if (this.value == "") {
      this.localValue = localStorage.getItem(this.item.id) ?? "";
      this.$emit("input", this.localValue);
    } else {
      this.localValue = this.value;
    }
  }

  updateValue(value: string) {
    localStorage.setItem(this.item.id, value);
    this.localValue = value;
    this.$emit("input", value);
  }
}
